import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MarineCustomerProposalComponent } from './module/Marine/customer-proposal/marine-customer-proposal/marine-customer-proposal.component';
import { MoCustomerProposalComponent } from './module/MarineOpen/mo-customer-proposal/mo-customer-proposal.component';
import { CustomerProposalComponent } from './module/home/customer-proposal/customer-proposal.component';
import { HomeComponent } from './module/home/home.component';
import { PaymentRedirectionComponent } from './module/home/payment-redirection/payment-redirection.component';
import { MsCustomerProposalComponent } from './module/marine-stop/ms-customer-proposal/ms-customer-proposal.component';
import { UwmailaccessComponent } from './module/uwmailaccess/uwmailaccess.component';
import { WcCustomerProposalComponent } from './module/wc/wc-customer-proposal/wc-customer-proposal.component';

import { MotorProposalCustomerViewComponent } from 'src/app/partner-portal/module/motor/motordetails/motor-proposal-customer-view/motor-proposal-customer-view.component';
import { EndorsementCustomerViewComponent } from './partner-portal/module/endorsement/endorsement-customer-view/endorsement-customer-view.component';
import { NewHeaderComponent } from './partner-portal/new-header/new-header.component';
import { RedirectPdfurlComponent } from './shared/components/redirect-pdf-url/redirect-pdf-url.component';
import { RedirectTinyUrlComponent } from './shared/components/redirect-tiny-url/redirect-tiny-url.component';
import { OtpVerificationCancellationComponent } from './otp-verification-cancellation/otp-verification-cancellation.component';
import { AdvancePaymentComponent } from './partner-portal/module/motor/motordetails/advance-payment/advance-payment.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/module/dashboard/dashboard.module').then(
            (m) => m.DashBoardModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'create-quote',
        loadChildren: () =>
          import('src/app/module/create-quote/create-quote.module').then(
            (m) => m.CreateQuoteModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'wallet',
        loadChildren: () =>
          import('src/app/module/walletstatement/walletstatement.module').then(
            (m) => m.WalletstatementModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'credit-balance',
        loadChildren: () =>
          import('src/app/module/credit-balance/credit-balance.module').then(
            (m) => m.CreditBalanceModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'wc-Dashboard',
        loadChildren: () =>
          import('src/app/module/dashboard/dashboard.module').then(
            (m) => m.DashBoardModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'payment-proposal',
        loadChildren: () =>
          import(
            'src/app/module/payment-proposals/payment-proposals.module'
          ).then((m) => m.PaymentProposalModule),
        canActivate: [AuthGuard],
      },



      {
        path: 'newproposal',
        loadChildren: () =>
          import('src/app/module/new-proposal/new-proposal.module').then(
            (m) => m.ProposalModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'newquote',
        loadChildren: () =>
          import('src/app/module/new-quote/new-quote.module').then(
            (m) => m.NewQuoteModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'policy',
        loadChildren: () =>
          import('src/app/module/policy/policy.module').then(
            (m) => m.PolicyModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'newendorsement',
        loadChildren: () =>
          import('src/app/module/policy/policy.module').then(
            (m) => m.PolicyModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'marine',
        loadChildren: () =>
          import('src/app/module/Marine/marine-module').then(
            (m) => m.MarineModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'MarineOpen',
        loadChildren: () =>
          import('src/app/module/MarineOpen/mo.module').then((m) => m.MOModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'MarineStop',
        loadChildren: () =>
          import('src/app/module/marine-stop/marine-stop.module').then(
            (m) => m.MarineStopModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'pli',
        loadChildren: () =>
          import('src/app/module/pli/pli.module').then((m) => m.PLIModule),
        canActivate: [AuthGuard],
      },



    ],
  },
  { path: 'customerproposal', component: CustomerProposalComponent },
  {
    path: 'marine-customerproposal',
    component: MarineCustomerProposalComponent,
  },
  { path: 'wc-customerproposal', component: WcCustomerProposalComponent },
  { path: 'mo-customerproposal', component: MoCustomerProposalComponent },
  { path: 'ms-customerproposal', component: MsCustomerProposalComponent },
  { path: 'sid/:shortId/:mobileNumber', component: RedirectTinyUrlComponent },
  { path: 'sid/:shortId', component: RedirectPdfurlComponent, canActivate: [] },
  { path: 'motor/customerView', component: MotorProposalCustomerViewComponent },
  { path: 'endorsement/customerView', component: EndorsementCustomerViewComponent },
  { path: 'cancellation/otpverify', component: OtpVerificationCancellationComponent },

  {
    path: 'uwmailaccess',
    component: UwmailaccessComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'partner-portal',
    component: NewHeaderComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/dashboard/dashboard.module'
          ).then((m) => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('src/app/module/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'make-payment',
        loadChildren: () =>
          import('src/app/module/payments/payments.module').then(
            (m) => m.PaymentsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'search',
        loadChildren: () =>
          import('src/app/module/search/search.module').then(
            (m) => m.SearchModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'portal-faqs/portal-faqs',
        loadChildren: () =>
          import('src/app/module/portal-faqs/portal-faqs.module').then(
            (m) => m.PortalFaqsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'uw-workbench/home',
        loadChildren: () =>
          import('src/app/module/uw-workbench/uw-workbench.module').then(
            (m) => m.UWWorkbenchModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('src/app/module/configuration/configuration.module').then(
            (m) => m.ConfigurationModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'wc',
        loadChildren: () =>
          import('src/app/module/wc/wc.module').then((m) => m.WCModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'qc',
        loadChildren: () =>
          import('src/app/module/QC/qc.module').then((m) => m.QCModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'engagement-tracker',
        loadChildren: () =>
          import(
            'src/app/module/engagement-tracker/engagement-tracker.module'
          ).then((m) => m.EngagementTrackerModule),
        canActivate: [AuthGuard],
      },

      {
        path: 'itticket',
        loadChildren: () =>
          import('src/app/module/it-ticket/it-ticket/it-ticket.module').then(
            (m) => m.itTicketModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'Training',
        loadChildren: () =>
          import('src/app/module/training/training.module').then(
            (m) => m.TrainingModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'my-profile',
        loadChildren: () =>
          import('src/app/module/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  { path: 'customerproposal', component: CustomerProposalComponent },
  {
    path: 'marine-customerproposal',
    component: MarineCustomerProposalComponent,
  },
  { path: 'wc-customerproposal', component: WcCustomerProposalComponent },
  { path: 'mo-customerproposal', component: MoCustomerProposalComponent },
  { path: 'ms-customerproposal', component: MsCustomerProposalComponent },
  { path: 'sid/:shortId/:mobileNumber', component: RedirectTinyUrlComponent },
  { path: 'sid/:shortId', component: RedirectPdfurlComponent, canActivate: [] },
  { path: 'motor/customerView', component: MotorProposalCustomerViewComponent },
  { path: 'endorsement/customerView', component: EndorsementCustomerViewComponent },
  { path: 'cancellation/otpverify', component: OtpVerificationCancellationComponent },
  { path: 'motor/advancepayment', component: AdvancePaymentComponent },

  {
    path: 'uwmailaccess',
    component: UwmailaccessComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'partner-portal',
    component: NewHeaderComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/dashboard/dashboard.module'
          ).then((m) => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'motor',
        loadChildren: () =>
          import('src/app/partner-portal/module/motor/motor.module').then(
            (m) => m.MotorModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('src/app/partner-portal/module/payments/payments.module').then(
            (m) => m.PaymentsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'claim',
        loadChildren: () =>
          import('src/app/partner-portal/module/claim/claim.module').then(
            (m) => m.ClaimModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'inspection',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/inspection/inspection.module'
          ).then((m) => m.InspectionModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'endorsement',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/endorsement/endorsement.module'
          ).then((m) => m.EndorsementModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'cancellation-old',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/cancellation-old/cancellation.module'
          ).then((m) => m.CancellationModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'cancellation',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/cancellation/cancellation.module'
          ).then((m) => m.CancellationModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'learning-center',
        loadChildren: () =>
          import('src/app/module/learning-center/learning-center.module').then(
            (m) => m.LearningCenterModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'insights',
        loadChildren: () =>
          import('src/app/partner-portal/module/insights/insights.module').then(
            (m) => m.InsightsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'privilege',
        loadChildren: () =>
          import(
            'src/app/partner-portal/module/privilege/privilege.module'
          ).then((m) => m.PrivilegeModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'qc-flow',
        loadChildren: () =>
          import('src/app/partner-portal/module/qc-flow/qc-flow.module').then(
            (m) => m.QcFlowModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'commercial/fire',
        loadChildren: () =>
          import('src/app/partner-portal/commercial/fire/fire.module').then(
            (m) => m.FireModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },

  { path: 'payment-redirection', component: PaymentRedirectionComponent },
  //{ path: 'engagement-tracker', component: EngagementTrackerComponent},
  // { path: 'partner-portal/commercial/fire', component: FireComponent },

  {
    path: '**',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
